import { render } from "./create-journey.vue?vue&type=template&id=b48cd928&lang=pug"
import script from "./create-journey.vue?vue&type=script&lang=js"
export * from "./create-journey.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__